import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const GOLD = '#B8892A';

// 以图搜物按钮 —— 纯内联控件(相机图标 + 隐藏 file input),放进主搜索框里(淘宝式)。
// 识图/结果反馈由父级用 aiMeta 显示;本组件只负责触发上传并把结果回传。
export default function ImageSearchButton({ onResults, onLoading, style }) {
  const { t } = useTranslation();
  const fileRef = useRef(null);

  const doImageSearch = async (file) => {
    if (!file) return;
    onLoading?.(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const { data } = await api.post('/smart-search/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onResults?.(data.data, { type: 'image', analysis: data.analysis, total: data.total });
    } catch (err) {
      const msg = err.response?.data?.error || 'Image search failed';
      onResults?.(null, { type: 'error', message: msg });
    } finally {
      onLoading?.(false);
    }
  };

  return (
    <>
      <button
        type="button"
        title={t('smartSearch.imageSearchTitle')}
        onClick={() => fileRef.current?.click()}
        style={style}
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
      </button>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={e => { const f = e.target.files?.[0]; if (f) doImageSearch(f); e.target.value = ''; }}
      />
    </>
  );
}
